import { Component, input, output } from '@angular/core';

/**
 * Coque d'un panneau : voile sombre, feuille remontant du bas (modale centrée au-delà de 760 px)
 * et poignée.
 *
 * @remarks
 * Mutualisée parce que le mécanisme, lui, se répète : fermeture au clic sur le voile **et**
 * `stopPropagation` sur la feuille pour qu'un clic à l'intérieur ne referme pas — le détail qu'on
 * oublie en recopiant. Point d'entrée unique pour ajouter plus tard la fermeture par Échap ou un
 * piège de focus.
 *
 * @example
 * ```html
 * <app-sheet-shell ariaLabel="Langue" (close)="closeLangSheet()">
 *   <h3>Langue</h3>
 * </app-sheet-shell>
 * ```
 */
@Component({
  selector: 'app-sheet-shell',
  // Le panneau est en position fixe : l'hôte ne doit pas occuper de place dans le flux de la page,
  // sans quoi il ajoute un écart de grille sous le contenu.
  styles: [':host { display: contents; }'],
  template: `
    <div class="scrim" (click)="close.emit()">
      <div
        class="sheet"
        [attr.aria-label]="ariaLabel()"
        (click)="$event.stopPropagation()"
        role="dialog"
        aria-modal="true"
      >
        <span class="grip"></span>
        <ng-content />
      </div>
    </div>
  `,
})
export class SheetShellComponent {
  /** Intitulé annoncé aux technologies d'assistance ; omis quand le panneau porte déjà un titre. */
  public readonly ariaLabel = input<string | null>(null);

  /** Demande de fermeture : clic sur le voile. */
  public readonly close = output<void>();
}
